var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M14.402 12.5L24.547 2.31c.544-.544.544-1.404 0-1.902-.543-.544-1.404-.544-1.902 0L12.5 10.598 2.31.408C1.766-.136.906-.136.408.408c-.544.543-.544 1.404 0 1.902L10.552 12.5.409 22.69c-.544.544-.544 1.404 0 1.902.271.272.634.408.95.408.318 0 .68-.136.952-.408l10.19-10.19 10.19 10.19c.272.272.634.408.951.408.317 0 .68-.136.951-.408.544-.543.544-1.404 0-1.902L14.402 12.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu_close.d3bccf1ec28d6aaba905c53023837f1f.svg";
export { ForwardRef as ReactComponent };